// AttendancePage.jsx
import AttendanceCalendar from './AttendanceCalendar';
import ClockPanel from './ClockPanel';

export default function AttendancePage() {
  return (
    <div className="max-w-6xl mx-auto px-4 py-8">
      <div className="bg-white/80 backdrop-blur-lg rounded-2xl shadow-xl p-8">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_400px] gap-8">
          <AttendanceCalendar />
          <ClockPanel />
        </div>
      </div>
    </div>
  );
}
